import { useState, useEffect } from 'react';

import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import * as usersService from '@frolight/services/api/usersService';

const useAssignUserToOrganisation = ( userId, organisationId ) => {

  const [ loading, setLoading ] = useState(false);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  useEffect(() => {
    let mounted = true;

    const abortController = new AbortController();

    const runEffect = async () => {
      if (mounted) setLoading(true);
      try {
        const response = await authenticatedAPIServiceCall(
          usersService.assignUserToOrganisation,
          {
            abortController: abortController,
            opts: {
              userId: userId,
              organisationId: organisationId
            }
          }
        );
        if (mounted) setData(response.data);
      } catch (err) {
        if (mounted) {
          if (err.name !== 'AbortError') {
            setError(err);
          }
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (userId && organisationId) {
      runEffect();
    }

    return () => {
      mounted = false;
      abortController.abort();
    }
  }, [ organisationId, userId ]);

  return { loading, error, data };
};

export default useAssignUserToOrganisation;